// extracted by mini-css-extract-plugin
export default {"eventDatetimeWrapper":"styles_eventDatetimeWrapper__6YIEs","day":"styles_day__AW3kj","month":"styles_month__eh-Ow","time":"styles_time__f0kEN","divider":"styles_divider__kFvkj"};